import { MONTH_DISPLAY, MONTH_NAMES, getGeneratedMonths } from '@/lib/country-month-pages';

interface MonthNavigationProps {
  month: number;
  slugPrefix: string;
}

export function MonthNavigation({ month, slugPrefix }: MonthNavigationProps) {
  // Only navigate to months that actually have a generated page — linking to an
  // ungenerated month produces a 404 (see getGeneratedMonths).
  const generated = getGeneratedMonths(slugPrefix).filter(m => m !== month);
  if (generated.length === 0) return null;

  // Nearest generated month below the current one (wrapping to the highest), and
  // nearest above (wrapping to the lowest), so the arrows always point somewhere real.
  const lower = generated.filter(m => m < month);
  const higher = generated.filter(m => m > month);
  const prevMonth = lower.length ? Math.max(...lower) : Math.max(...generated);
  const nextMonth = higher.length ? Math.min(...higher) : Math.min(...generated);

  const prevSlug = `${slugPrefix}-in-${MONTH_NAMES[prevMonth - 1]}`;
  const nextSlug = `${slugPrefix}-in-${MONTH_NAMES[nextMonth - 1]}`;

  return (
    <div className="mb-8 flex items-center justify-between border-t border-border-subtle pt-6">
      <a
        href={`/${prevSlug}`}
        className="flex items-center gap-1 text-sm font-medium text-accent-primary hover:underline"
      >
        &larr; {MONTH_DISPLAY[prevMonth - 1]}
      </a>
      <a
        href={`/${nextSlug}`}
        className="flex items-center gap-1 text-sm font-medium text-accent-primary hover:underline"
      >
        {MONTH_DISPLAY[nextMonth - 1]} &rarr;
      </a>
    </div>
  );
}
